import AppComponent from '../base/app-component.ts';
import { templateParseToElement } from '../lib/template-parse.ts';

export class DettaglioImpresa extends AppComponent {
  static override componentName = 'wc-dettaglio-impresa';

  protected override get templateId() { return 'dettaglio-impresa'; }

  private impresaId = 0;

  protected override afterRender(): void {
    this.impresaId = this.attributeNumber('impresa-id');
    if (!this.impresaId) {
      this.showError('ID impresa non specificato');
      return;
    }
    this.loadDettaglio();
  }

  private async loadDettaglio(): Promise<void> {
    const result = await this.api.imprese.dettaglio(this.impresaId);
    const container = this.$('[data-content]');
    if (!container) return;

    if (!result.ok) {
      if (result.status === 404) {
        container.innerHTML =
          '<div class="text-center py-4">' +
          '<p class="text-muted mb-3">Impresa non trovata</p>' +
          '<a href="/imprese" class="btn btn-outline-secondary btn-sm">' +
          '<i class="bi bi-arrow-left me-1"></i>Torna alla ricerca</a></div>';
      } else {
        this.showError(result.error);
      }
      return;
    }

    const data = result.data as Record<string, unknown>;
    templateParseToElement('dettaglio-impresa-scheda', container, data);

    this.loadLavoratori();
    this.setupActions();
  }

  private async loadLavoratori(): Promise<void> {
    const container = this.$('[data-lavoratori]');
    if (!container) return;

    const result = await this.api.imprese.lavoratori(this.impresaId);
    if (!result.ok) {
      templateParseToElement('shared-error-state', container, { message: result.error });
      return;
    }

    templateParseToElement('shared-lavoratori-risultati', container, {
      lavoratori: result.data.risultati,
      count: result.data.count,
      action: 'dettaglio-lavoratore',
    });
  }

  private setupActions(): void {
    this.delegate.on<MouseEvent>('click', '[data-action="dettaglio-lavoratore"]', (e) => {
      const row = (e.target as HTMLElement).closest<HTMLElement>('[data-id]');
      if (row?.dataset.id) {
        window.location.href = `/lavoratori/${row.dataset.id}`;
      }
    });
  }

  private showError(message: string): void {
    const container = this.$('[data-content]');
    if (container) {
      templateParseToElement('shared-error-state', container, { message });
    }
  }
}
